import { FormControl, ListItemText } from '@mui/material'
import { MenuItem, Typography, SelectField } from '@carto/meridian-ds/components'
import { useAppSelector } from 'app/state'
import { Operations, OperationType } from 'features/analysis/types'
import { getEnrichedDatasetById } from 'features/builder/state/keplerGlSlice'
import { FormattedMessage } from 'react-intl'
import TypeTag from 'features/common/ui/TypeTag'

interface SecondSourceColumnProps {
  source?: string
  column?: string
  placeholderId?: string
  showLabel?: boolean
  operation?: OperationType
  margin?: 'none' | 'dense' | 'normal'
  onChange: (string) => void
}

function SourceColumnSelector({
  source,
  column,
  placeholderId = 'analysis.addColumn.secondColumnPlaceholder',
  operation,
  showLabel = true,
  margin = 'normal',
  onChange
}: SecondSourceColumnProps) {
  const dataset = useAppSelector((state) => getEnrichedDatasetById(state, source as string))
  const secondSourceFromDataTree = useAppSelector((state) => state.analysis.secondSourceTable)
  const isDisabled = operation === OperationType.COUNT || (!source && !secondSourceFromDataTree)
  const supportedTypes = operation && operation !== OperationType.COUNT ? Operations[operation].supportedTypes : []
  const fieldsToDisplay = dataset?.metadata?.schema
    ? dataset?.metadata?.schema?.filter((f) => (supportedTypes.length ? supportedTypes.includes(f.type) : true))
    : secondSourceFromDataTree?.schema?.filter((f) => (supportedTypes.length ? supportedTypes.includes(f.type) : true))

  const selectedColumn = source && fieldsToDisplay?.find((field) => field.name === column)

  return (
    <FormControl margin={margin}>
      <SelectField
        displayEmpty
        value={column || ''}
        labelId="geom-field"
        label={showLabel && <FormattedMessage id="analysis.intersect.secondColumn" />}
        onChange={(e) => onChange(e.target.value)}
        renderValue={(selected) => {
          if (selected) return <Typography variant="body2">{selectedColumn?.name}</Typography>
          return (
            <Typography variant="body2" color="text.hint">
              <FormattedMessage id={placeholderId} />
            </Typography>
          )
        }}
        size="small"
        disabled={isDisabled}
      >
        {fieldsToDisplay?.map((field) => {
          return (
            <MenuItem key={field.name} value={field.name}>
              <ListItemText>{field.name}</ListItemText>
              <TypeTag type={field.type} />
            </MenuItem>
          )
        })}
      </SelectField>
    </FormControl>
  )
}

export default SourceColumnSelector
